
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './PepXelement.html?raw';
import topic from 'dojo/topic';
import on from 'dojo/on';



import domStyle from 'dojo/dom-style';
import domConstruct from 'dojo/dom-construct';
import domClass from 'dojo/dom-class';
import domAttr from 'dojo/dom-attr';
import { EntityViewTypes } from "../../../moreCore/UI/EntityBased/EntityView/EntityViewTypes";
import { FeatureHelpers } from "../../../more/Helpers";
import GenericEntityView from '../../../moreCore/UI/EntityBased/EntityView/GenericEntityView';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import { PEP } from "../PepTypes";



class PepXelement extends compose(_WidgetBaseSP) {
    templateString: any = template;

    //// nodes 
    mainLabel: HTMLDivElement;
    hoverContainer: HTMLDivElement;
    noteContainerCompact: HTMLDivElement;
    specialNoteContainer: HTMLElement;
    specialNoteContainerCompact: HTMLSpanElement;
    dayNotesContainer: HTMLDivElement;
    dayNotesContainerCompact: HTMLSpanElement;
    dayDescriptionContainer: HTMLDivElement;
    dayDescriptionContainerCompact: HTMLSpanElement;

    private clickable: boolean = false;

    setData(data: PEP.XAxisDescriptor) {


        // alles resetten:
        domConstruct.empty(this.specialNoteContainer);
        domConstruct.empty(this.hoverContainer);
        domConstruct.empty(this.mainLabel);
        domConstruct.empty(this.dayDescriptionContainer);
        domConstruct.empty(this.dayNotesContainer);
        this.clickable = false;


        domAttr.set(this.mainLabel, "innerHTML", data.label);

        // weitere Elemente ausklappbar im hoverContainer
        let scrollContainer = domConstruct.create("div",
            {
                "className": "scrollContainer",
                "innerHTML": ""
            },
            this.hoverContainer
        );
        
        if (data.emplDayBaseEntityViewData && FeatureHelpers.hasFeature("PEP/EntityViewEmbeddedInDayHeader")) {
            
            let entityviewdata = data.emplDayBaseEntityViewData as EntityViewTypes.EntityViewResponse<any> | string;
            let container = domConstruct.create("div", {
                className: "dayHeaderEntityview"
            }, this.dayDescriptionContainer);

            this.clickable = true;

            this._showEntityviewContent(entityviewdata, container);
            this._showEntityviewContent(entityviewdata, scrollContainer);
        }

        let noteContainer = domConstruct.create("div",
            {
                "className": "",
                "innerHTML": ""
            },
            scrollContainer
        );

        
        let notesCount = data.specialNotes?.length;
        if (notesCount > 5) { // bei mehr als 5 Einträgen: der unteren Zeile eine Klasse geben die dem User zeigt es gäbe noch mehr
            domClass.add(this.specialNoteContainer, "overflowing");
        }

        if (notesCount > 0) {
            let index: number = 0;
            this.clickable = true;

            
            
            for (let note of data.specialNotes) {
                index++;

                // farbigen Punkt einblenden
                let noteLine = domConstruct.create("div", {}, this.specialNoteContainer);
                //<i class="fas fa-circle" style="color:{3};margin-right:0.3em;"></i>
                let icon = domConstruct.create("i", {
                    "className": "fas fa-circle",
                    "title": note.label
                }, noteLine);

                domStyle.set(icon, "color", note.coloration);

                icon = lang.clone(icon);
                domConstruct.place(icon, this.specialNoteContainerCompact);

                let label = domConstruct.create("span", { "innerHTML": note.label, "title": note.label }, noteLine);


                //// wenn nur einzelner Eintrag: unter dem Datum mit Label anzeigen (im Kompaktcontainer)                
                //if (bShowSingleNote) {
                //    label = lang.clone(label);
                //    domConstruct.place(label, this.specialNoteContainerCompact);
                //}

                icon = lang.clone(icon);
                domConstruct.place(icon, noteContainer);

                let labelSpan = domConstruct.create("span", { "innerHTML": note.label }, noteContainer);

                if (note.dateRange) {
                    let labelDate = domConstruct.create("div", { "innerHTML": note.dateRange, "className": "daterange" }, noteContainer);
                }

                domStyle.set(icon, "color", note.coloration);
            }
        }

        // Tagesanmerkungen
        if (data.emplDayBaseNoteOfTheDay) {
            let element = domConstruct.create("pre", { "innerHTML": data.emplDayBaseNoteOfTheDay, "className": "dayBaseNote" }, this.dayNotesContainer);

            element = lang.clone(element);
            domConstruct.place(element, noteContainer);

            let icon = domConstruct.create("i", {
                "className": "dayNotes secondaryTXT fas fa-comment",
                "title": data.emplDayBaseNoteOfTheDay
            }, this.dayNotesContainerCompact);

            this.clickable = true;
        }

        // Tagesbeschreibung
        if (data.emplDayBaseDescription) {
            let element = domConstruct.create("pre", { "innerHTML": data.emplDayBaseDescription, "className": "dayBaseDescription" }, this.dayDescriptionContainer);

            element = lang.clone(element);
            domConstruct.place(element, noteContainer);

            let icon = domConstruct.create("i", {
                "className": "dayDescription secondaryTXT fas fa-info",
                "title": data.emplDayBaseDescription
            }, this.dayDescriptionContainerCompact);

            this.clickable = true;
        }

       

        if (this.clickable == true) {
            domAttr.set(this.specialNoteContainer, "display", "block");
            domClass.add(this.domNode, "clickable hoverDark");
        }
    }

    private _showEntityviewContent(viewcontent: EntityViewTypes.EntityViewResponse<any> | string, parentNode: HTMLElement) {
        let view = new GenericEntityView();
        view.setContextName("PEProsterDayHeader");
        view.setupWithoutEntity(viewcontent, null, parentNode);
        on(view, "change", lang.hitch(this, this._onChange_EntityView));
    }   
    private _onChange_EntityView() {
        this.emit("update");
    }
    private _onClick_domNode(evt: MouseEvent) {

        if (this.clickable != true) {
            return;
        }

        topic.publish("PEPclick_xElementSpecialNote", this);

        evt.stopPropagation();
        domClass.toggle(this.domNode, "clicked");

    }

    private _onClick_Global(sender: any) {
        if (this._destroyed) return;
        if (sender != this) {
            domClass.remove(this.domNode, "clicked");
        }
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this._setupSubscriptions();
    }

    destroy(): void {

        this._removeSubscriptions();
        super.destroy.apply(this, arguments as any);

        
    }

    private subscriptions: Array<dojo.Handle> = [];
    protected _setupSubscriptions(): void {
        this.subscriptions = [];

        this.subscriptions.push(topic.subscribe("PEPclick_global", lang.hitch(this, this._onClick_Global)));
        this.subscriptions.push(topic.subscribe("PEPclick_xElementSpecialNote", lang.hitch(this, this._onClick_Global)));
    }

    private _removeSubscriptions(): void {
        //console.debug("pepXelement destroy");
        for (let handle of this.subscriptions) {
            handle.remove();
        }

        this.subscriptions = [];
    }

    startup(): void {
        super.startup.apply(this, arguments as any);

    }


}

export default mdsWidget(PepXelement);